import _ from 'lodash'

export function cleanCashDrawers (settingsBlob) {
  const references = getAvailableReferences(settingsBlob)
  _.get(settingsBlob, 'cashDrawers.availableDrawers', [])
    .forEach(it => cleanCashDrawer(it, settingsBlob, references))

  _.get(settingsBlob, 'cashDrawers.stationsAssignment', [])
    .forEach(it => cleanAssignment(it, settingsBlob, references))
}

export function cleanCashDrawer (drawer, settingsBlob, references = null) {
  if (!references) {
    references = getAvailableReferences(settingsBlob)
  }

  if (!references.stations.includes(drawer.stationId)) {
    drawer.stationId = null
  }

  if (!references.printers.includes(drawer.printerId)) {
    drawer.printerId = null
  }

  if (!references.drawers.includes(drawer.moneyTransfersFrom)) {
    drawer.moneyTransfersFrom = 'MAIN_SAFE'
  }

  if (!references.drawers.includes(drawer.moneyTransfersTo)) {
    drawer.moneyTransfersTo = 'MAIN_SAFE'
  }
}

export function cleanAssignment (assignment, settingsBlob, references = null) {
  if (!references) {
    references = getAvailableReferences(settingsBlob)
  }

  assignment.drawers = assignment.drawers.filter(it => references.drawers.includes(it))
  if (!references.drawers.includes(assignment.defaultDrawer)) {
    assignment.defaultDrawer = null
  }
}

function getAvailableReferences (settingsBlob) {
  return {
    printers: _.get(settingsBlob, 'printing.printers', []).map(it => it.id),
    drawers: [
      ..._.get(settingsBlob, 'cashDrawers.availableDrawers', []).map(it => it.id),
      'MAIN_SAFE'
    ],
    stations: _.get(settingsBlob, 'stations', []).map(it => it.id)
  }
}
